<div class="solocal-page">
  <img class="solocal-img" src="../../assets/images/logo-solocal.svg" height="auto">
</div>
